import React from "react";
import { Flame, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { STREAK_BADGES } from "./StreakBadges";

/* Me page shelf: the 4 daily-play streak badges with the date each was earned + countdown to the next one */
export const StreakBadgeWall = ({ ta }) => {
  const { user } = useAuth();
  if (!user) return null;
  const count = user.play_streak?.count || 0;
  const best = user.play_streak?.best || 0;
  const have = new Set(user.streak_badges || []);
  const dates = user.streak_badge_dates || {};
  const next = STREAK_BADGES.find((b) => !have.has(b.id) && count < b.days) || STREAK_BADGES.find((b) => !have.has(b.id));
  const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "");
  return (
    <div className="rl-card p-4" data-testid="streak-badge-wall">
      <div className="flex items-center justify-between">
        <div className="font-bold text-sm flex items-center gap-1.5"><Flame className="w-4 h-4 text-orange-500" />{ta ? "தினசரி விளையாட்டு பதக்கங்கள்" : "Daily streak badges"}</div>
        <span className="text-[11px] text-slate-500" data-testid="streak-wall-count">{ta ? "இப்போது" : "Now"} <b className="text-orange-600">{count}</b> · {ta ? "சிறந்தது" : "Best"} {best}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 mt-3">
        {STREAK_BADGES.map((b) => {
          const earned = have.has(b.id);
          return (
            <div key={b.id} className={`rounded-xl border p-2 text-center ${earned ? "bg-gradient-to-b from-amber-50 to-amber-100 border-amber-300" : "bg-slate-50 border-slate-200"}`} data-testid={`streak-wall-${b.id}`}>
              <div className={`text-2xl leading-none ${earned ? "" : "grayscale opacity-40"}`}>{b.icon}</div>
              <div className="text-[10px] font-bold text-slate-700 mt-1">{b.days} {ta ? "நாள்" : "days"}</div>
              <div className="text-[9px] mt-0.5 h-3">{earned ? <span className="text-amber-700 font-semibold" data-testid={`streak-wall-date-${b.id}`}>{fmtDate(dates[b.id]) || (ta ? "பெற்றது" : "earned")}</span> : <Lock className="w-2.5 h-2.5 inline text-slate-400" />}</div>
              {b.bonus && <div className="text-[8px] font-bold text-emerald-700">+₹ bonus</div>}
            </div>
          );
        })}
      </div>
      {(user.chicken_champion_weeks || []).length > 0 && (
        <div className="mt-3 rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 px-3 py-2 flex items-center gap-2" data-testid="chicken-champion-badge">
          <span className="text-2xl leading-none">🐔👑</span>
          <div className="flex-1 leading-tight"><div className="text-[12px] font-black text-amber-800">{ta ? "Chicken Road வார சாம்பியன்" : "Chicken Road Weekly Champion"} ×{user.chicken_champion_weeks.length}</div><div className="text-[10px] text-amber-700">{ta ? "நீளமான crossing" : "Longest crossing"} · {user.chicken_champion_weeks.slice(-3).join(", ")}</div></div>
        </div>
      )}
      {next ? (
        <div className="mt-3" data-testid="streak-wall-next">
          <div className="flex justify-between text-[11px] text-slate-600"><span>{next.icon} {ta ? "அடுத்த பதக்கம்" : "Next badge"}: <b>{next.days} {ta ? "நாள்" : "days"}</b></span><span className="font-bold text-orange-600" data-testid="streak-wall-countdown">{Math.max(next.days - count, 0)} {ta ? "நாள் மீதம்" : "days to go"}</span></div>
          <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden mt-1"><div className="h-full bg-gradient-to-r from-orange-400 to-amber-400" style={{ width: `${Math.min(100, (count / next.days) * 100)}%` }} /></div>
          <div className="text-[10px] text-slate-400 mt-1">{ta ? "ஒவ்வொரு நாளும் ஒரு ஆட்டம் ஆடினால் streak தொடரும்" : "Play at least one game a day to keep the streak alive"}</div>
        </div>
      ) : <div className="mt-2 text-[11px] font-semibold text-amber-700" data-testid="streak-wall-complete">{ta ? "எல்லா பதக்கங்களும் பெற்றீர்கள்! 👑" : "All badges earned! 👑"}</div>}
    </div>
  );
};
